import { Col, Divider, Row } from 'antd'
import * as React from 'react'
import testIds from 'test_ids.json'

import KCol from '../../UI-Elements/Layout/KCol'
import { CollectionProps } from '../convention'
import CategorySegmentImage from './Image'
import Availability from './Tag/Availability'

type Props = {
  onRowClick?: (categorySegment: ICategorySegment) => void
  showAvailability?: boolean
}

const List: React.FC<CollectionProps<ICategorySegment, Props>> = ({
  collection,
  props: { onRowClick, showAvailability }
}) => {
  return (
    <Row gutter={[0, 12]}>
      <KCol span={24}>
        {collection.map((segment, index) => (
          <React.Fragment key={segment.id}>
            <If condition={index === 0}>
              <Divider className="my-0" />
            </If>
            <Row
              key={segment.id}
              className="full-width d-flex align-items-center py-2 pointer"
              onClick={() => onRowClick?.(segment)}
              role="button"
              wrap={false}
              data-testid={testIds.category_segment.list_item}>
              <Col flex="none">
                <CategorySegmentImage member={segment} />
              </Col>
              <Col flex="auto">
                <h6 className="mb-0 ml-3">{segment.label}</h6>
              </Col>
              <If condition={showAvailability}>
                <Col flex="none">
                  <Availability member={segment} />
                </Col>
              </If>
            </Row>
            <Divider className="my-0" />
          </React.Fragment>
        ))}
      </KCol>
    </Row>
  )
}

export default List
